import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "scroll-y mh-325px my-5" }
const _hoisted_2 = { class: "d-flex mx-4 pb-1 align-items-baseline" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "h1 fs-2" }, "Notifications", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "py-2 text-center border-top d-none" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-color-gray-600 btn-active-color-primary"
  }, "View All")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewCommunicationNotification = _resolveComponent("NewCommunicationNotification")!
  const _component_CallRescheduledNotification = _resolveComponent("CallRescheduledNotification")!
  const _component_CallCancelledNotification = _resolveComponent("CallCancelledNotification")!
  const _component_NotifyManagerConflictNotification = _resolveComponent("NotifyManagerConflictNotification")!
  const _component_NotifyMemberConflictNotification = _resolveComponent("NotifyMemberConflictNotification")!
  const _component_NewInvitationNotification = _resolveComponent("NewInvitationNotification")!
  const _component_NewRequestNotification = _resolveComponent("NewRequestNotification")!
  const _component_InvitationResponseNotification = _resolveComponent("InvitationResponseNotification")!
  const _component_RequestResponseNotification = _resolveComponent("RequestResponseNotification")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.markAllAsRead && _ctx.markAllAsRead(...args))),
          class: "ms-auto btn btn-sm btn-outline btn-outline-secondary text-white cursor-pointer"
        }, "Mark all as read")
      ]),
      (_ctx.recentNotifications.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentNotifications, (notification) => {
              return (_openBlock(), _createElementBlock("div", {
                key: notification.notificationId,
                class: "px-8 notify-wrapper bg-hover-light"
              }, [
                (notification.type === 1)
                  ? (_openBlock(), _createBlock(_component_NewCommunicationNotification, {
                      key: 0,
                      notification: notification
                    }, null, 8, ["notification"]))
                  : _createCommentVNode("", true),
                (notification.type === 2)
                  ? (_openBlock(), _createBlock(_component_CallRescheduledNotification, {
                      key: 1,
                      notification: notification
                    }, null, 8, ["notification"]))
                  : _createCommentVNode("", true),
                (notification.type === 3)
                  ? (_openBlock(), _createBlock(_component_CallCancelledNotification, {
                      key: 2,
                      notification: notification
                    }, null, 8, ["notification"]))
                  : _createCommentVNode("", true),
                (notification.type === 4)
                  ? (_openBlock(), _createBlock(_component_NotifyManagerConflictNotification, {
                      key: 3,
                      notification: notification
                    }, null, 8, ["notification"]))
                  : _createCommentVNode("", true),
                (notification.type === 5)
                  ? (_openBlock(), _createBlock(_component_NotifyMemberConflictNotification, {
                      key: 4,
                      notification: notification
                    }, null, 8, ["notification"]))
                  : _createCommentVNode("", true),
                (notification.type === 6)
                  ? (_openBlock(), _createBlock(_component_NewInvitationNotification, {
                      key: 5,
                      notification: notification
                    }, null, 8, ["notification"]))
                  : _createCommentVNode("", true),
                (notification.type === 7)
                  ? (_openBlock(), _createBlock(_component_NewRequestNotification, {
                      key: 6,
                      notification: notification
                    }, null, 8, ["notification"]))
                  : _createCommentVNode("", true),
                (notification.type === 8)
                  ? (_openBlock(), _createBlock(_component_InvitationResponseNotification, {
                      key: 7,
                      notification: notification
                    }, null, 8, ["notification"]))
                  : _createCommentVNode("", true),
                (notification.type === 9)
                  ? (_openBlock(), _createBlock(_component_RequestResponseNotification, {
                      key: 8,
                      notification: notification
                    }, null, 8, ["notification"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_5
  ]))
}